import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ValidationStep =
  | "idle"
  | "mismatch"
  | "success"
  | "error"
  | "override";

interface PaymentValidationState {
  step: ValidationStep;
  apiError: string | null;
  isMatch: boolean;
}

const initialState: PaymentValidationState = {
  step: "idle",
  apiError: null,
  isMatch: false,
};

const paymentValidationSlice = createSlice({
  name: "paymentValidation",
  initialState,
  reducers: {
    setStep(state, action: PayloadAction<ValidationStep>) {
      state.step = action.payload;
    },
    setApiError(state, action: PayloadAction<string | null>) {
      state.apiError = action.payload;
    },
    setIsMatch(state, action: PayloadAction<boolean>) {
      state.isMatch = action.payload;
    },
    resetValidation(state) {
      state.step = "idle";
      state.apiError = null;
      state.isMatch = false;
    },
  },
});

export const {
  setStep,
  setApiError,
  setIsMatch,
  resetValidation,
} = paymentValidationSlice.actions;

export default paymentValidationSlice.reducer;